import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import BalanzaInfo from '../../components/BalanzaInfo'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_PESO_DESTARE } from '../../../../config/forms'
import { Card } from 'react-bootstrap'
import { INTERVALO_CORTO, INTERVALO_LARGO } from '../../../../config/settings'
import DialogoErrorPesado from '../../components/pesado/DialogoErrorPesado'
import ConfiguracionPesadoDestare from '../../components/pesado/ConfiguracionPesadoDestare'
import PrinterPicker from '../../../Printer/containers/PrinterPicker'
import { toast } from 'react-toastify'
import PesadoDestareAuto from './PesadoDestareAuto'
import PesadoDestareManual from './PesadoDestareManual'

function PesadoDestare0 (props) {
  const {
    cea,
    balanza,
    pesaje,
    equilibrio,
    pesoMinimo,
    pesoMaximo,
    pesoMinimoDiferencia,
    modoBarreras,
    diferenciaTara,
    cpe,
    reimprimirTicket,
    printerDestare,
    pesadoAuto // Si el pesaje esta en automatico se desabilitan los campos para escribir peso
  } = props

  const [textoPesado, setTextoPesado] = useState('')
  const [pesadoEnCabina, setPesadoEnCabina] = useState(false)
  const [time, setTime] = useState(0)
  const [init, setInit] = useState(false)

  const reset = useCallback(() => {
    const { change: formChange } = props
    formChange('pesoDestare', '')
    formChange('numero', '')
    props.resetDiferenciaPesoTara()
  }, [props])

  const borrarCpeDestare = useCallback((numero) => {
    props.deleteCpeEnDestare(numero)
    props.updateCpeDestare(null)
    props.updateConsultaCea(null)
    props.resetConsultaCeaDestare()
    reset()
  }, [props, reset])

  useEffect(() => {
    const { pesoMinimoDiferencia, numero, cpe, change: formChange } = props

    const updateParametrosForm = () => {
      const { change: formChange, urlDestare } = props
      formChange('urlDestare', urlDestare)
    }

    async function setUp () {
      setTextoPesado('')
      props.updateParametroInteger('REPESODE', 0)
      props.getCpeEnDestare()
      formChange('pesoDestare', '')
      formChange('numero', '')

      const peso = await props.requestPesoDestare()
      props.escribirPesoDestare(peso)

      updateParametrosForm()

      if (parseInt(peso) < parseInt(pesoMinimoDiferencia) && cpe) {
        borrarCpeDestare(numero)
      }
    }

    const intervalParametros = setInterval(async () => {
      const parametros = await props.queryParametrosDestare()
      console.log(parametros)
    }, [INTERVALO_LARGO])

    // Si el pesado esta en modo automatico recibo el peso que se guardo en CEA cuando se encuentra CPE. Sino se carga todo manualmente.
    const intervalDestare = setInterval(async () => {
      const { cpe, cea, change: formChange, diferenciaTara, pesadoAuto } = props

      props.getCpeEnDestare()

      if (cpe && !cea) {
        props.requestDatosConsultaCeaDestare(cpe.numero)
      }

      if (cea && cpe && !diferenciaTara) {
        const { change: formChange } = props
        formChange('pesoDestare', cpe && cpe.pesoTara)
        formChange('numero', cpe && cpe.numero)
        props.calcularDiferenciaPesoTara(cea.pesoTaraOrigen, cpe.pesoTara)
      }

      if (cpe || cea) {
        if (pesadoAuto) {
          const peso = await props.requestPesoDestare()
          formChange('pesoDestare', peso && peso)
          props.escribirPesoDestare(peso)
          if ((parseInt(peso) < parseInt(pesoMinimoDiferencia)) && cpe) {
            props.escribirPesoDestare(peso)
            borrarCpeDestare(cpe.numero)
            formChange('pesoDestare', '')
            if (textoPesado === 'Repeso tara') {
              setTextoPesado('Pesado tara')
              props.updateEnclavamiento(1)
              props.updateParametroInteger('REPESODE', 0)
            }
          }
        }
      }
    }, INTERVALO_CORTO)

    if (!init) {
      setUp()
      setInit(true)
    }

    return () => {
      clearInterval(intervalDestare)
      clearInterval(intervalParametros)
    }
  }, [props, init, textoPesado, borrarCpeDestare])

  const intervaloPesadoManual = () => {
    const { numero } = props
    setTime(30)

    const intervalPesadoManual = setInterval(() => {
      if (time > 0) {
        setTime(time - 1)
      }
      if (time === 0) {
        clearInterval(intervalPesadoManual)
        borrarCpeDestare(numero)
      }
    }, 1000)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const { change: formChange, pesadoAuto, pesoMinimoDiferencia, modo } = props
    let peso
    if (pesadoAuto) {
      // En pesaje automatico pide el peso solo para verificar que la balanza
      // tenga un camion arriba antes de hacer el submit
      peso = await props.requestPesoDestare()
      formChange('pesoDestare', peso && peso)
      props.escribirPesoDestare(peso)
    }

    if ((parseInt(peso) > parseInt(pesoMinimoDiferencia) || modo === 'manual')) {
      if (textoPesado === 'Pesado tara') {
        props.handleSubmit(false)
      } else {
        props.handleSubmit(true, props.change)
        setTextoPesado('Pesado tara')
        props.updateEnclavamiento(1)
      }
    } else {
      formChange('pesoDestare', '')
      formChange('numero', '')
      toast.error('Peso no válido.')
    }

    if (!pesadoAuto) {
      intervaloPesadoManual()
    }
  }

  const updateRepeso = () => {
    const { cpe, change: formChange, repesoDestare } = props
    if (repesoDestare === 1) {
      setTextoPesado('Pesado tara')
      props.updateEnclavamiento(1)
      props.updateParametroInteger('REPESODE', 0)
    } else {
      setTextoPesado('Repeso tara')
      props.updateEnclavamiento(0)
      props.updateParametroInteger('REPESODE', 1)
      if (cpe) {
        borrarCpeDestare(cpe.numero)
      }
    }
    formChange('pesoDestare', '')
    formChange('numero', '')
  }

  const pesarEnCabina = () => {
    const { change: formChange } = props
    setPesadoEnCabina(!pesadoEnCabina)
    formChange('numero', '')
  }

  const reimprimirCerealAdherido = () => {
    const { numero } = props
    props.reimprimirCerealAdherido(numero)
  }

  const selectPrinter = (printerDestare, printerName) => {
    props.selectPrinter(printerDestare, printerName)
    props.updateParametroText('IMPDESTA', printerDestare)
  }

  const onPrinterChange = () => {
    props.resetPrinter()
  }

  const onBlurInput = () => {
    const { cpe } = props
    if (!cpe) {
      document.getElementsByName('numero')[0].focus()
    }
  }

  const showToast = (error, numero) => {
    toast.error(<div>CTG: <b>{numero}</b><br /> {error}</div>, { autoClose: false })
  }

  const bza = {
    balanza,
    pesaje,
    modoBarreras,
    enclavamiento: (equilibrio) ? 'Si' : 'No',
    pesoMinimo,
    pesoMaximo
  }

  const showCerealAdherido = (parseInt(diferenciaTara) > parseInt(pesoMinimoDiferencia))

  return (
    <div className='container-destare'>
      {cpe && <DialogoErrorPesado
        cpe={cpe}
        borrarCpe={borrarCpeDestare}
        show
        onBlurInput={onBlurInput}
        updateShow={props.updateShowPesadoDestare}
        showToast={showToast}
      />
      }

      <PrinterPicker
        onSubmit={selectPrinter}
        place='destare'
        name='printerDestare'
        show={printerDestare == null}
        titulo='Impresora para ticket de descarga'
      />

      <h3>Configuración de la Balanza</h3>
      <BalanzaInfo balanza={bza} />
      <br />

      <Card style={{ margin: '0 2%' }}>
        <div className='container-cabecera-pesado'>
          <h4>{textoPesado}</h4>

          <div className='container-info-destare'>
            {/* Modo automatico & manual */}
            {(pesadoAuto)
              ? <PesadoDestareAuto
                pesadoEnCabina={pesadoEnCabina}

                handleSubmit={handleSubmit}
                onBlurInput={onBlurInput}
              />
              : <PesadoDestareManual
                cpe={cpe}
                handleSubmit={handleSubmit}
                onBlurInput={onBlurInput}
                deleteCpeDestare={borrarCpeDestare}
              />
            }

          </div>

          <div className='resultados-acciones-destare' />
        </div>

        <div className='datos-camion-destare'>
          {(!pesadoAuto) && <div className='box-dato-destare'>
            <h6>Peso tara</h6>
            {(cea && cpe && diferenciaTara) && <h1>{cpe.pesoTara}</h1> }
          </div> }
          <div className='box-dato-destare'>
            <h6>Patente</h6>
            {(cea && cpe && diferenciaTara) && <h1>{cea.camion}</h1> }
          </div>
          <div className='box-dato-destare'>
            <h6>Diferencia de peso tara (Kg.)</h6>
            {(cea && cpe && diferenciaTara) && <h1>{diferenciaTara}</h1> }
          </div>

          {(pesadoAuto) && <div className='box-dato-destare'>
            <h6>Peso tara origen (Kg.)</h6>
            {(cea && cpe && diferenciaTara) && <h1>{cea.pesoTaraOrigen}</h1> }
          </div>
          }

          {(!pesadoAuto) && cea && <div className='box-dato-origen-destare'>
            <div className='dato-origen-destare'>
              <h5 style={{ fontWeight: 'bold' }}>Peso bruto TQ</h5>
              {(cea && cea.pesoBruto) && <h4 style={{ fontWeight: 'bold' }}>{cea.pesoBruto}</h4> }
            </div>

            <div className='dato-origen-destare'>
              <h6>Peso tara origen</h6>
              {(cea && cea.pesoTaraOrigen) && <h5>{cea.pesoTaraOrigen}</h5> }
            </div>

            <div className='dato-origen-destare'>
              <h6>Peso neto origen</h6>
              {(cea && cea.pesoNetoOrigen) && <h5>{cea.pesoNetoOrigen}</h5> }
            </div>
          </div>
          }

        </div>
      </Card>
      <ConfiguracionPesadoDestare
        pesarEnCabina={pesarEnCabina}
        reimprimirTicket={reimprimirTicket}
        cerealAdherido={reimprimirCerealAdherido}
        updateRepeso={updateRepeso}
        pesadoAuto={pesadoAuto}
        onPrinterChange={onPrinterChange}
        show={showCerealAdherido}
      />
    </div>
  )
}

const selector = formValueSelector(FORM_PESO_DESTARE)

const mapStateToProps = (state) => ({
  cea: state.pesado.consultaCeaDestare || null,
  cpe: state.pesado.cpePesadoDestare || null,
  balanza: state.pesado.balanzaDestare,
  pesaje: state.pesado.pesajeDestare,
  equilibrio: state.pesado.enclavamientoDestare,
  pesoMinimoDiferencia: state.pesado.pesoMinimoDiferenciaDestare,
  pesoMinimo: state.pesado.pesoMinimoDestare,
  pesoMaximo: state.pesado.pesoMaximoDestare,
  numero: selector(state, 'numero'),
  pesoCabezal: selector(state, 'pesoDestare'),
  urlDestare: state.pesado.urlDestare,
  diferenciaTara: state.pesado.diferenciaTara,
  modo: state.pesado.pesajeDestare,
  modoBarreras: state.pesado.modoBarrerasDestare,
  repesoDestare: state.pesado.repesoDestare,
  forzarBarreras: state.pesado.forzarBarrerasDestare,
  printerDestare: state.pesado.printerDestare
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PESO_DESTARE,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(PesadoDestare0))
